// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2":"b384f011","814":"b384f011","833":"1fe3f0c6"}[chunkId] + ".chunk.css";
};